// Auth
export const AUTH_SIGN_IN_SUCCESS = 'AUTH_SIGN_IN_SUCCESS';
export const AUTH_SIGN_OUT_SUCCESS = 'AUTH_SIGN_OUT_SUCCESS';
export const AUTH_MFA_ENABLED_SUCCESS = 'AUTH_MFA_ENABLED_SUCCESS';
export const AUTH_MFA_DISABLED_SUCCESS = 'AUTH_MFA_DISABLED_SUCCESS';
